<template>
  <div class="content">
      <div class="header">
            <p @click="toSign" style="padding:0 12px"><img src="@/assets/img/back1.png" alt=""></p>
            <!-- <van-row>
                <van-col span="12">
                    <h1>总积分：{{this.integralTotal}}</h1>
                </van-col>
                <template>
                    <van-col span="12">
                         <select class="selector" @change="getValue" v-model="current">
                            <option v-for="(item,index) in selectlist" :key="index">{{item}}</option>
                        </select>
                    </van-col>
                </template>
                
            </van-row> -->
      </div>
      <div class="list">
            <div class="show">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了~"
                        :immediate-check="false"
                        @load="onLoad"
                        :error.sync="error"
                        error-text="请求失败，点击重新加载"
                        :offset="15"
                    >
                        <van-cell-group border v-for="(item,index) in list" :key="index">
                            <van-cell size="large" :title="item.remark" :label="item.createTime"  :value="item.amount" />
                        </van-cell-group>
                    </van-list>
                <div v-if="!this.list" style="text-algin:center;color: #ccc">暂无数据</div>
            </div>
      </div>
  </div>
</template>

<script>
import {Icon, Col, Row, List, Toast, Button} from 'vant';
import { wxRequest } from '@/api/user'

export default {
    data() {
        return {
            postform: {
                id: localStorage.getItem('id'),
                phone: localStorage.getItem('phone'),
                pageNo: 1,
                perPageNum: 15,
                flowType: null,
            },
            selectlist: ['全部','获取','使用'],
            current: '',
            list: [],
            // refreshing: false,
            loading: false, 		// 是否处在加载状态
            finished: false, 		// 是否已加载完成
            error:false,
            allPage: 0,				// 数据总页数
            totalNum:0,             // 数据总条数
            integralTotal: localStorage.getItem('integralTotal')        // 总积分
        }
    },
    methods: {
        toSign() {
            this.$router.push({
                path: '/appSignin',
                query: {
                    phone: localStorage.getItem('phone'),
                    id: localStorage.getItem('id')
                }
            })
        },
        getValue() {
            this.postform.pageNo = 1;
            this.list = [];
            this.loading = false; 		// 是否处在加载状态
            // this.finished = false;      // 是否已加载完成
            if (this.current == '全部') {
                this.postform.flowType = null;
                this.onLoad();
                console.log(this.finished)
            }
            else if(this.current == '获取') {
                this.postform.flowType = 1;
                this.onLoad();
                console.log(this.finished)
            }
            else{
                this.postform.flowType = 2;
                this.onLoad();
                console.log(this.finished)
            }
        },

        onLoad() {
            this.getData();
            console.log("onload被调用了")
            console.log(this.finished)
        },

        // onRefresh() {
        //     // 清空列表数据
        //     this.list = [];
        //     this.finished = false;

        //     // 重新加载数据
        //     // 将 loading 设置为 true，表示处于加载状态
        //     this.loading = true;
        //     this.onLoad();
        // },

        getData() {
            //获取数据
            wxRequest('xxtx/app/sign/integral/flow',this.postform,'post').then(res => {
                if (res.data.code == "200") {
                    console.log(res)
                    this.postform.pageNo++;
                    console.log(this.postform.pageNo)
                    this.totalNum = res.data.data.totalNum;
                    // this.list = res.data.data.resultList;
                    var newlist = []
                    newlist = res.data.data.resultList;
                    this.allPage = res.data.data.allPage;

                    this.loading = false;
                    
                    if (newlist == null || newlist.length === 0) {
                        this.finished = true
                        return;
                    }

                    this.list = this.list.concat(newlist);
                    if (this.list.length >= this.totalNum) {
                        this.finished = true
                    }
                }
                else {
                    Toast.fail(res.data.result)
                }
            })
        }
    },
    created() {
        this.current = this.selectlist[0];
        // this.getData();
        this.getValue();
    }
}
</script>

<style scoped lang="less">
.orange {
    color: orange;
}

.green {
    color: palegreen;
}
select:focus{outline:none;}
.content {
   .header {
       height: 80px;
    //    background-color: #2cb5e8;
       border-radius: 0 0 8px 8px;
       color: #fff;
       background: transparent;
       h1 {
           padding: 10px 15px;
           font-size: 18px;

       }
        .selector {
            position: absolute;
            top: 10px;
            right: 14px;
            background: none;
            border: 0;
            color: #fff;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
            font-size: 12px;
            border-radius: 12px;
            padding: 2px 6px;
            // background-color: rgba(105, 103, 103, 0.3);
            // option {
            //     background-color: #2cb5e8;
            // }
        }
   }
   .list {
        display: flex;
        flex-direction: column ;
        justify-content: center;
        align-items: center;
        margin-top: -40px;
        width: 100%;
       .show {
            // display: flex;
            // flex-direction: column ;
            // justify-content: center;
            // align-items: center;
            width: 100%;
            margin: 0 10px;
            padding: 0 10px;
            background-color: #fff;
            border-radius: 5px;
            // box-shadow: 0 0 5px rgb(87, 65, 65);
       }
    //    ul {
    //         display: flex;
    //         flex-direction: column ;
    //         justify-content: center;
    //         align-items: center;
    //         margin: 0 15px;
    //         padding: 0 20px;
    //         background-color: #fff;
    //         border-radius: 5px;
    //         box-shadow: 0 0 5px rgb(100, 100, 100);
    //         li {
    //             width: 100%;
    //             height: 60px;
    //             border-bottom: 1px solid #ccc;
    //             margin-top: 8px;
    //             .left {
    //                 width: 80%;
    //                 float: left;
    //                 .textname,.gettime {
    //                     padding: 6px 10px;
    //                 }
    //                 .gettime {
    //                     font-size: 14px;
    //                     color: #ccc;
    //                 }
    //             }
    //             .right {
    //                 float: right;
    //                 padding: 20px 10px;
    //             }
    //         }
    //         li:last-child {
    //             border-bottom: 0;
    //         }
    //    }
   } 
}
</style>